import { css } from 'styled-components';
export var createBorder = function createBorder(_ref) {
  var direction = _ref.direction,
    outerTopLeft = _ref.outerTopLeft,
    innerTopLeft = _ref.innerTopLeft,
    outerBottomRight = _ref.outerBottomRight,
    innerBottomRight = _ref.innerBottomRight;
  return css(["\n  border: 0;\n  box-shadow: inset -1px -1px 0 0\n      ", ",\n    inset 1px 1px 0 0\n      ", ",\n    inset -2px -2px 0 0\n      ", ",\n    inset 2px 2px 0 0\n      ", ";\n"], direction == 'extrude' ? outerBottomRight : innerTopLeft, direction == 'extrude' ? outerTopLeft : innerBottomRight, direction == 'extrude' ? innerBottomRight : outerTopLeft, direction == 'extrude' ? innerTopLeft : outerBottomRight);
};
export var border = function border() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref2$direction = _ref2.direction,
    direction = _ref2$direction === void 0 ? 'extrude' : _ref2$direction;
  return createBorder({
    direction: direction,
    outerBottomRight: css(["\n      ", "\n    "], function (_ref3) {
      var theme = _ref3.theme;
      return theme.colors.borderDarkest;
    }),
    innerBottomRight: css(["\n      ", "\n    "], function (_ref4) {
      var theme = _ref4.theme;
      return theme.colors.borderDark;
    }),
    outerTopLeft: css(["\n      ", "\n    "], function (_ref5) {
      var theme = _ref5.theme;
      return theme.colors.borderLightest;
    }),
    innerTopLeft: css(["\n      ", "\n    "], function (_ref6) {
      var theme = _ref6.theme;
      return theme.colors.borderLight;
    })
  });
};
export var windowBorder = function windowBorder() {
  var _ref7 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref7$direction = _ref7.direction,
    direction = _ref7$direction === void 0 ? 'extrude' : _ref7$direction;
  return createBorder({
    direction: direction,
    outerBottomRight: css(["\n      ", "\n    "], function (_ref8) {
      var theme = _ref8.theme;
      return theme.colors.borderDarkest;
    }),
    innerBottomRight: css(["\n      ", "\n    "], function (_ref9) {
      var theme = _ref9.theme;
      return theme.colors.borderDark;
    }),
    outerTopLeft: css(["\n      ", "\n    "], function (_ref10) {
      var theme = _ref10.theme;
      return theme.colors.borderLight;
    }),
    innerTopLeft: css(["\n      ", "\n    "], function (_ref11) {
      var theme = _ref11.theme;
      return theme.colors.borderLightest;
    })
  });
};
export var scrollBarBorder = function scrollBarBorder() {
  var _ref12 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref12$direction = _ref12.direction,
    direction = _ref12$direction === void 0 ? 'extrude' : _ref12$direction;
  return createBorder({
    direction: direction,
    outerBottomRight: css(["\n      ", "\n    "], function (_ref13) {
      var theme = _ref13.theme;
      return theme.colors.borderDarkest;
    }),
    innerBottomRight: css(["\n      ", "\n    "], function (_ref14) {
      var theme = _ref14.theme;
      return theme.colors.borderDark;
    }),
    outerTopLeft: css(["\n      ", "\n    "], function (_ref15) {
      var theme = _ref15.theme;
      return theme.colors.borderLight;
    }),
    innerTopLeft: css(["\n      ", "\n    "], function (_ref16) {
      var theme = _ref16.theme;
      return theme.colors.borderLightest;
    })
  });
};
export default border;